import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { Beneficiary, HistoricalTransaction, PaymentReport, Trade, TransactionReason } from 'ah-api-gateways';
import TradeTransactionBankInfo from './info/TradeTransactionBankInfo.vue';
import TradeTransactionInfo from './info/TradeTransactionInfo.vue';
import { reactive, ref, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhWalletsState } from '..';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeTransactionDetailsModal',
  props: {
    trade: null,
    buttonTitle: { default: 'View Related Payment' },
    title: { default: 'Related Payment' },
    payment: null
  },
  setup(__props: any) {

const props = __props as { trade: Trade, buttonTitle: string, title: string, payment: PaymentReport };



const state = reactive<{
  transaction: HistoricalTransaction | null;
  beneficiary: Beneficiary | null;
}>({
  transaction: null,
  beneficiary: null,
});

const modal = ref<InstanceType<typeof BModal> | null>(null);

const requestManager = useRequestManager();

const walletState = useAhWalletsState();

watch(
  () => props.trade,
  () => {
    requestManager.manager
      .sameOrCancelAndNew(
        'loadTransaction',
        walletState.services.wallet.listWalletTransactions({
          sort: 'createdAt',
          sortDirection: 'DESC',
          pageSize: 1,
          tradeId: props.trade.id,
          reason: TransactionReason.TRADE_BUY_CURRENCY_CLIENT_TO_BENEFICIARY,
        })
      )
      .subscribe((res) => (state.transaction = res.list[0]));
  },
  { immediate: true }
);

watch(
  () => props.payment,
  () => {
    requestManager.manager
      .sameOrCancelAndNew(
        'loadBeneficiary',
        walletState.services.beneficiary.getBeneficiary(props.payment.beneficiaryId!)
      )
      .subscribe((res) => (state.beneficiary = res));
  },
  { immediate: true }
);

function show() {
  modal.value?.show();
}

function hide() {
  requestManager.manager.cancel('loadTransaction');
  requestManager.manager.cancel('loadBeneficiary');
  modal.value?.hide();
}

return { __sfc: true,props, state, modal, requestManager, walletState, show, hide, BModal, TradeTransactionBankInfo, TradeTransactionInfo }
}

})